import { useEffect, useRef } from "react";

import { useRecoilCallback, useRecoilValue } from "recoil";

import {
  modalBulkFindReplaceFetchPreviewCallback,
  modalBulkFindReplacePollingPreviewCallback,
} from "Pages/RecipientsList/recoil/callbacks/modalBulkFindReplace";
import { modalBulkFindReplaceState } from "Pages/RecipientsList/recoil/state/modalBulkFindReplace";

const INITIAL_DELAY = 125;
const MAX_DELAY = 5000;

const useModalBulkFindReplacePreview = (): void => {
  const timer = useRef<any>(null);
  const delay = useRef(INITIAL_DELAY);

  const {
    FindColumn,
    FindCaseSensitive,
    FindType,
    idTask,
    pollingIteration,
    previewStatus,
    show,
  } = useRecoilValue(modalBulkFindReplaceState);

  const fetchPreview = useRecoilCallback(
    modalBulkFindReplaceFetchPreviewCallback,
    [],
  );

  const previewPolling = useRecoilCallback(
    modalBulkFindReplacePollingPreviewCallback,
    [],
  );

  useEffect(() => {
    void fetchPreview();
  }, [fetchPreview]);

  useEffect(() => {
    if (idTask !== undefined && idTask > 0 && pollingIteration > 0) {
      timer.current = setTimeout(previewPolling as () => void, delay.current);
      delay.current = Math.min(delay.current * 2, MAX_DELAY);
    }

    return () => {
      clearTimeout(timer.current);
    };
  }, [idTask, pollingIteration, previewPolling]);

  useEffect(() => {
    if (previewStatus === "ready" || previewStatus === "error") {
      delay.current = INITIAL_DELAY;
    }
  }, [previewStatus]);

  useEffect(() => {
    if (!show) {
      clearTimeout(timer.current);
      delay.current = INITIAL_DELAY;
    }
  }, [show]);
};

export default useModalBulkFindReplacePreview;
